import MailOutlineIcon from '@mui/icons-material/MailOutline';

const PriorityLowIcon: React.FC = () => {
  return <MailOutlineIcon fontSize="small" style={{ width: '0.8em', color: '#3C419A' }} />;
};

export default PriorityLowIcon;
